<script setup lang="ts">
import EditPostClassDrawer from '@/pages/erp/du/org/view/du-class-drawer.vue'
import type { PostClassProperties } from '@/pages/erp/du/org/db/du-class-types'
import Swal from 'sweetalert2'
definePage({
    meta: {
        action: 'manage',
        subject: 'DUCLASS',
    },
})

const compId = ref(useStorage('compNo').value)
const orgType = ref()
const depNo = ref()
const postNo = ref()

// Data table options
const currentPage = ref(1)
const size = ref(10)
const sortOrder = ref()
const orderByCol = ref()

// Update data table options
const updateOptions = (options: any) => {
  sortOrder.value = options.sortBy[0]?.key
  orderByCol.value = options.sortBy[0]?.order
}

// Headers

const grid1Headers = [
    { title: '組織類別', key: 'orgType' },
    { title: '部門代號', key: 'depNo' },
    { title: '職位代號', key: 'postNo' },
    { title: '上層部門代號', key: 'upperDepNo' },
    { title: '上層職位代號', key: 'upperPostNo' },
    { title: '操作', key: 'actions', sortable: false}
]


// champ 後端分頁是從 0 開始
const page = computed((): number => currentPage.value - 1)

// 👉 Fetching users
const { data: postClasssData, execute: fetchPostClasss } = await useApi<any>(createUrl('/du/org/class/searchPostClass', {
  query: {
    compId,
    orgType,
    depNo,
    postNo,
    page,
    size,
    orderByCol,
    sortOrder,
  },
}))

const datas = computed((): PostClassProperties[] => postClasssData.value.data.postClassPage.content)
const totalDatas = computed(() => postClasssData.value.data.postClassPage.totalElements)

console.log('datas: ', datas)

const isEditDataDrawerVisible = ref(false)
const isNewData = ref(false)
const isCopyData = ref(false)

let voData = {}


const createData = () => {
  isEditDataDrawerVisible.value = true
  isNewData.value = true
  isCopyData.value = false
}

const editData = (postClassData: PostClassProperties) => {
  voData = postClassData
  console.log('editPostClass: ', voData)
  isEditDataDrawerVisible.value = true
  isNewData.value = false
  isCopyData.value = false
}

const copyData = (postClassData: PostClassProperties) => {
    voData = postClassData
    console.log('copyPostClass: ', voData)
    isEditDataDrawerVisible.value = true
    isNewData.value = true
    isCopyData.value = true
}

// 👉 Add new data
const addNewData = async (postClassData: PostClassProperties) => {
  await $api('/du/org/class/createPostClass', {
    method: 'POST',
    body: { postClass: postClassData },
  }).then(() => {
      $swal({
      position: 'top-end',
      icon: 'success',
      title: '新增成功',
      showConfirmButton: false,
      timer: 1500,
      customClass: {
        confirmButton: 'btn btn-primary',
      },
      buttonsStyling: false,
    })
  })

  // refetch data
  fetchPostClasss()
}

const updateData = async (postClassData: PostClassProperties) => {
  await $api('/du/org/class/updatePostClass', {
    method: 'PUT',
    body: { postClass: postClassData },
  }).then(() => {
      $swal({
      position: 'top-end',
      icon: 'success',
      title: '修改成功',
      showConfirmButton: false,
      timer: 1500,
      customClass: {
        confirmButton: 'btn btn-primary',
      },
      buttonsStyling: false,
    })
  })

  // refetch data
  fetchPostClasss()
}

  // 👉 Delete data
const deleteData = async (postClassData: PostClassProperties) => {
  const { compId,orgType,depNo,postNo } = postClassData
    $swal({
    title: `確定要刪除 ${postClassData.postNo} 資料?`,
    icon: "warning",
    showCancelButton: true,
    confirmButtonColor: "#3085d6",
    cancelButtonColor: "#d33",
    confirmButtonText: "確定",
    cancelButtonText: "取消"
  }).then((result) => {
    if (result.isConfirmed) {
        $api(`/du/org/class/deletePostClass`, {
        method: 'DELETE',
        query: {
          compId,orgType,depNo,postNo
        }
      }).then(() => {
          $swal({
          position: 'top-end',
          title: "刪除成功",
          timer: 1500,
          icon: "success"
        });

        // refetch Data
        fetchPostClasss()
      })
    }
  });

}

const clickRow = (event, select) => {
  console.log('clickRow: ', event, select)
  editData(select.item)
}

</script>

<template>
  <!-- 👉 Widgets -->

  <VCard class="mb-6">
    <VCardItem class="pb-2 pt-2">
      <VCardTitle>搜尋</VCardTitle>
    </VCardItem>

    <VCardText>
      <VRow>
        <VCol
         cols="12"
         sm="2"
        >
          <AppTextField
            v-model="compId"
            clearable
            clear-icon="mdi-close-circle"
            placeholder="請輸入公司別"
          />
        </VCol>
        <VCol
         cols="12"
         sm="2"
        >
          <AppTextField
            v-model="orgType"
            clearable
            clear-icon="mdi-close-circle"
            placeholder="請輸入組織類別"
          />
        </VCol>
        <VCol
         cols="12"
         sm="2"
        >
          <AppTextField
            v-model="depNo"
            clearable
            clear-icon="mdi-close-circle"
            placeholder="請輸入部門代號"
          />
        </VCol>
        <VCol
         cols="12"
         sm="2"
        >
          <AppTextField
            v-model="postNo"
            clearable
            clear-icon="mdi-close-circle"
            placeholder="請輸入職位代號"
          />
        </VCol>
      </VRow>
    </VCardText>

    <VDivider />

    <VCardText class="d-flex flex-wrap gap-4">
      <VSpacer />

      <div class="app-user-search-filter d-flex align-center flex-wrap gap-4">
        <!-- 👉 Add button -->
        <VBtn
                prepend-icon="tabler-plus"
                @click="createData"
        >
          新增職位階層
        </VBtn>
      </div>
    </VCardText>

    <VDivider />

    <!-- SECTION datatable -->
    <VDataTableServer
            v-model:items-per-page="size"
            v-model:page="currentPage"
            :items="datas"
            :items-length="totalDatas"
            :headers="grid1Headers"
            class="text-no-wrap"
            @update:options="updateOptions"
    >

      <template #item.orgType="{ item }">
          <div class="text-body-1 text-high-emphasis">
              {{ item.orgType }}
          </div>
      </template>

      <template #item.depNo="{ item }">
          <div class="text-body-1 text-high-emphasis text-capitalize">
              <div class="font-weight-medium ">
                {{ toText(item.depNo) }}
              </div>
              <div class="text-sm">
                {{ toCode(item.depNo) }}
              </div>
          </div>
      </template>

      <template #item.postNo="{ item }">
          <div class="text-body-1 text-high-emphasis text-capitalize">
              <div class="font-weight-medium ">
                  {{ toText(item.postNo) }}
              </div>
              <div class="text-sm">
                  {{ toCode(item.postNo) }}
              </div>
          </div>
      </template>

      <template #item.upperDepNo="{ item }">
          <div class="text-body-1 text-high-emphasis text-capitalize">
              <div class="font-weight-medium ">
                {{ toText(item.upperDepNo) }}
              </div>
              <div class="text-sm">
                {{ toCode(item.upperDepNo) }}
              </div>
          </div>
      </template>

      <template #item.upperPostNo="{ item }">
          <div class="text-body-1 text-high-emphasis text-capitalize">
              <div class="font-weight-medium ">
                {{ toText(item.upperPostNo) }}
              </div>
              <div class="text-sm">
                {{ toCode(item.upperPostNo) }}
              </div>
          </div>
      </template>

      <!-- Actions -->
      <template #item.actions="{ item }">
          <IconBtn @click="editData(item)">
              <VIcon icon="tabler-edit" />
              <v-tooltip
                      activator="parent"
                      location="bottom"
              >編輯</v-tooltip>
          </IconBtn>
          <IconBtn @click="copyData(item)">
              <VIcon icon="tabler-copy" />
              <v-tooltip
                      activator="parent"
                      location="bottom"
              >複製</v-tooltip>
          </IconBtn>
          <IconBtn @click="deleteData(item)">
              <VIcon icon="tabler-trash" />
              <v-tooltip
                      activator="parent"
                      location="bottom"
              >刪除</v-tooltip>
          </IconBtn>
      </template>

      <!-- pagination -->
      <template #bottom>
        <TablePagination
                v-model:page="currentPage"
                v-model:size="size"
                :items-per-page="size"
                :total-items="totalDatas"
        />
      </template>
    </VDataTableServer>
    <!-- SECTION -->
  </VCard>
  <!-- 👉 Edit -->
  <EditPostClassDrawer
          v-model:isDrawerOpen="isEditDataDrawerVisible"
          :postClass-data="voData"
          :is-new="isNewData"
          :is-copy="isCopyData"
          @create-data="addNewData"
          @update-data="updateData"
  />

</template>
